import React from "react";

function Projectex({title, link, desc, language}) {
    return (
        <div className="proj">
            <div className="proj-header">
            <span><a href={link} target="_blank" rel="noreferrer"> {title}</a></span><span className="workex-language">{language}</span>
            </div> 
            <div className="proj-desc">
            {desc}
            </div>
        </div>
    );
}

export default Projectex;